export default __webpack_public_path__ + "static/media/img-8.a9fec94c.jpg";